/**
 *
 *
 * @author Arian Khosravi <arian.khosravi@aofl.com>
 */
class ClickTracker {
  /**
   * Creates an instance of ClickTracker.
   *
   * @param {Array} config
   * @param {Function} callback
   * @param {HTMLElement} [rootElement=document]
   */
  constructor(config, callback, rootElement = document) {
    this.config = config;
    this.callback = callback;
    this.rootElement = rootElement;

    this.trackFn = (...args) => this.track(...args);
    this.elemConfig = null;
  }
  /**
   *
   */
  init() {
    this.rootElement.addEventListener('click', this.trackFn, true);
  }
  /**
   *
   */
  deinit() {
    this.rootElement.removeEventListener('click', this.trackFn, true);
  }
  /**
   *
   * @param {Event} e
   */
  track(e) {
    const domScope = this.findDomScope(e.target);
    this.callback(e, domScope);
  }
  /**
   *
   * @param {HTMLElement} elem
   * @return {HTMLElement|false}
   * @memberof ClickTracker
   */
  findDomScope(elem) {
    let domScope = false;
    let shadowElem = false;
    while (elem && elem !== this.rootElement) {
      if (!domScope && this.shouldTrack(elem) && elem.getAttribute('dom-scope')) {
        domScope = elem.getAttribute('dom-scope');
      }
      elem = elem.parentNode;
      if (domScope && elem !== null && this.elemConfig !== null && Array.isArray(this.elemConfig.parents)) {
        let tmpElem = elem;
        let index = this.elemConfig.parents.indexOf(tmpElem.tagName);

        if (typeof elem.tagName === 'undefined' && typeof elem.host !== 'undefined' && index === -1) {
          tmpElem = elem.host;
          index = this.elemConfig.parents.indexOf(tmpElem.tagName);
          shadowElem = true;
        }

        if (shadowElem && index !== -1) {
          domScope += '-' + tmpElem.getAttribute('dom-scope');
          this.elemConfig = null;
        }
      }
      if (elem === this.rootElement && domScope) {
        return domScope;
      }
    }

    return false;
  }
  /**
   *
   * @param {HTMLElement} elem
   * @return {Boolean}
   * @memberof ClickTracker
   */
  shouldTrack(elem) {
    for (let i = 0; i < this.config.length; i++) {
      const trackElem = this.config[i];
      if (elem.tagName === trackElem.tagName) {
        this.elemConfig = trackElem;
        if (typeof trackElem.attributes === 'undefined') return true;
        for (const attrKey in trackElem.attributes) {
          if (!trackElem.attributes.hasOwnProperty(attrKey)) continue;
          if (trackElem.attributes[attrKey] === elem.getAttribute(attrKey)) {
            return true;
          }
        }
      }
    }

    this.elemConfig = null;
    return false;
  }
}

export {
  ClickTracker
};
